import { Turnstile } from '@marsidev/react-turnstile';
import { useTurnstile } from '@/hooks/useTurnstile';

interface TurnstileFieldProps {
  widgetProps: ReturnType<typeof useTurnstile>['widgetProps'];
  widgetError?: string | null;
  error?: string;
}

export const TurnstileField = ({ widgetProps, widgetError, error }: TurnstileFieldProps) => (
  <div className="mt-4">
    <Turnstile {...widgetProps} />
    {(widgetError || error) && <p className="text-red-500 text-sm mt-1">{widgetError ?? error}</p>}
  </div>
);
